import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { useProjectCategoryUIContext } from "../ProjectCategoryUIContext";
import { ProjectCategoryEditDialogHeader } from "./ProjectCategoryDialogHeader";
import { ProjectCategoryEditForm } from "./ProjectCategoryEditForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/projectCategory/projectCategoryAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";

export const ProjectCategoryEditDialog = ({ id, show, onHide }) => {
  // ProjectCategory UI Context
  const projectCategoryUIContext = useProjectCategoryUIContext();
  const projectCategoryUIProps = useMemo(() => {
    return {
      initProjectCategory: projectCategoryUIContext.initProjectCategory,
      queryParams: projectCategoryUIContext.queryParams,
      setQueryParams: projectCategoryUIContext.setQueryParams,
    };
  }, [projectCategoryUIContext]);

  // BenefisCategory Redux state
  const dispatch = useDispatch();
  const { actionsLoading, projectCategoryForEdit, error } = useSelector(
    (state) => ({
      actionsLoading: state.projectCategory.actionsLoading,
      projectCategoryForEdit: state.projectCategory.projectCategoryForEdit,
      error: state.projectCategory.error,
    }),
    shallowEqual
  );

  if (error) {
    toast.error(error, toastOption);
  }

  useEffect(() => {
    // server call for getting ProjectCategory by id
    dispatch(actions.fetchCategoryProject(id));
  }, [id, dispatch]);

  const saveProjectCategory = (projectCategory) => {
    if (!id) {
      dispatch(actions.createProjectCategory(projectCategory)).then(
        (response) => {
          toast.success(response.message, toastOption);
          dispatch(
            actions.fetchProjectCategories(projectCategoryUIProps.queryParams)
          ).then(() => onHide());
        }
      );
    } else {
      dispatch(actions.updateProjectCategory(projectCategory)).then(
        (response) => {
          toast.success(response.message, toastOption);
          dispatch(
            actions.fetchProjectCategories(projectCategoryUIProps.queryParams)
          ).then(() => onHide());
        }
      );
    }
  };

  return (
    <Modal show={show} onHide={onHide} aria-labelledby="modal-sizes-title-lg">
      <ProjectCategoryEditDialogHeader id={id} />
      <ProjectCategoryEditForm
        saveProjectCategory={saveProjectCategory}
        actionsLoading={actionsLoading}
        projectCategory={
          projectCategoryForEdit|| projectCategoryUIProps.initProjectCategory
        }
        onHide={onHide}
      />
    </Modal>
  );
};
